module.exports = __webpack_public_path__ + "static/media/img1-1.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cebolla/nutricheck_foliar/N/img1-1.png
// module id = 1393
// module chunks = 3